import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { i18nReducer } from 'react-redux-i18n'
import { reducer as formReducer } from 'redux-form'
import { reducer as toastrReducer } from 'react-redux-toastr'

import users from './users'
import calculations from './calculations'
import contracts from './contracts'
import countries from './countries'
import deposits from './deposits'
import infos from './infos'
import payments from './payments'
import invoices from './invoices'
import calculator from './calculator'
import parameters from './parameters'
import translations from './translations'

export default {
  routing: routerReducer,
  i18n: i18nReducer,
  form: formReducer,
  toastr: toastrReducer,
  users,
  calculations,
  contracts,
  countries,
  deposits,
  infos,
  payments,
  invoices,
  calculator: combineReducers({
    dashboard: calculator('dashboard').reducer,
    buy_tokens_form: calculator('buy_tokens_form').reducer
  }),
  parameters,
  translations
}



// WEBPACK FOOTER //
// ./src/modules/index.js